import {BaseDao} from "../BaseDao";
import {ApiHelper} from "../../apiHelper";
import {ConstantMan} from "../../constantMan";
import {Observable} from "rxjs";
import {BuySchedule} from "../../../models/buySchedule";

export class FormatDao extends BaseDao {

    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.FORMATS, apiHelper);
    }

    public find(search: Object): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/find';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, search, headers);
    }
}
